import { StateConstraint } from '@/contentful/types';
import { userLocationType } from '@/hooks/geo';
import { ConstrainedExitIntentCF, ExitIntentCF } from '@/types';
import { getStateConstraintToApply } from '@/utils/constraint';

import ExitIntent from './ExitIntent';

interface Props {
  exitIntentConfig: ExitIntentCF | ConstrainedExitIntentCF;
  userLocation: userLocationType;
}

const isLocationConstrained = (
  config: ExitIntentCF | ConstrainedExitIntentCF
): config is ConstrainedExitIntentCF => {
  return 'exitIntentConstraints' === config.sys.contentType.sys.id;
};

export default function ConstrainedExitIntent({
  exitIntentConfig,
  userLocation,
}: Props) {
  if (isLocationConstrained(exitIntentConfig)) {
    const { constraints, default: defaultValue } = exitIntentConfig.fields;

    if (!constraints || !defaultValue) {
      return null;
    }

    const exitIntent = getStateConstraintToApply({
      constraints: constraints as unknown as StateConstraint[],
      defaultValue,
      userLocation,
    });
    return <ExitIntent config={exitIntent} />;
  }

  // regular exit intent type, no location constraints
  return <ExitIntent config={exitIntentConfig} />;
}
